import request from '@/utils/request';

// 查询用户的卡
export function getCard() {
  return request({
    url: `/h5/getCard`,
    method: 'get'
  });
}

// 卡挂失
export function cardLoss(cardId, params) {
  return request({
    url: `/h5/cardLoss?cardId=${cardId}&role=${params}`,
    method: 'get'
  });
}

// /h5/addCard  newCardSn 补卡传后两个 oldCardSn cardId
export function addOrChangeCard(data) {
  return request({
    url: `/cardHouse/h5/addCard?newCardSn=${data.newCardSn}&oldCardSn=${data.oldCardSn}&cardId=${data.cardId}`,
    method: 'get'
  });
}
